import React, { useCallback, useEffect, useState } from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';
import { ApiManager } from "../../core/api-manager";

async function updateData(slug, idUser) {
    const response = await ApiManager.sendAuthenticatedRequest(`/custom/${slug}`, { idUser });
    if (response.success === 0) return null;
    const body = response;
    return typeof body === 'string' ? body : JSON.stringify(body , null , 4);
}

function RevenueCatModal({ title, action, idUser, show, onClose }) {
    const [response, setResponse] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchData = useCallback(async () => {
        if (!idUser) return;
        setIsLoading(true);
        setError(null);
        try {
            const body = await updateData(action, idUser);
            console.log(body)
            setResponse(body);
        } catch (exception) {
            setError(exception);
            setResponse(null);
        } finally {
            setIsLoading(false);
        }
    }, [action, idUser]);

    useEffect(() => {
        if (!show) return;
        setResponse(null);
        fetchData();
    }, [show, fetchData]);

    return (
        <Modal show={show} onHide={onClose} centered size="lg">
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {isLoading ? (
                    <div className="d-flex align-items-center gap-2">
                        <Spinner animation="border" size="sm" />
                        <span>Caricamento...</span>
                    </div>
                ) : (
                    <textarea
                        readOnly
                        className="form-control bg-light text-black"
                        style={{ minHeight: 240, fontFamily: 'monospace' }}
                        value={
                            response ??
                            (error ? String(error?.message ?? error) : 'Nessun dato disponibile.')
                        }
                    />
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>
                    Chiudi
                </Button>
                <Button variant="primary" onClick={fetchData} disabled={isLoading}>
                    Aggiorna
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export function ModalRcUserStatus({ idUser, show, onClose }) {
    return (
        <RevenueCatModal
            title="Stato sottoscrizione Revenue Cat"
            action="admin_get_user_status"
            idUser={idUser}
            show={show}
            onClose={onClose}
        />
    );
}

export function ModalRcUserCredits({ idUser, show, onClose }) {
    return (
        <RevenueCatModal
            title="Stato crediti Revenue Cat"
            action="admin_get_user_balance"
            idUser={idUser}
            show={show}
            onClose={onClose}
        />
    );
}
